import { z } from 'zod';

export const dialectSchema = z.enum(['ows', 'ohip']);
export type APIDialect = z.infer<typeof dialectSchema>;
